import Swiper from 'swiper';
const eventsSlider = document.querySelectorAll(".events-slider .slider");

const setEventsCounter = (slider) => {
  const slides = slider.querySelectorAll(".swiper-slide");
  const activeSlide = slider.querySelector(".swiper-slide-active");
  const counterActive = slider.querySelector(".events__pagination-active");
  const counterAmount = slider.querySelector(".events__pagination-amount");
  let futureSlides = [];
  let pastSlides = [];

  slides.forEach((el) => {
    if(el.classList.contains("events-slider__slide--feature")){
      futureSlides.push(el);
    }
    else{
      pastSlides.push(el);
    }
  })

  if(activeSlide.classList.contains("events-slider__slide--feature")){
    futureSlides.forEach((el, index) => {
      if(el == activeSlide){
        counterActive.innerText = index + 1;
        counterAmount.innerText = futureSlides.length;
      }
    })  
  }
  else{
    pastSlides.forEach((el, index) => {
      if(el == activeSlide){
        counterActive.innerText = index + 1;
        counterAmount.innerText = pastSlides.length;
      }
    })
  }
}

if(eventsSlider){
    eventsSlider.forEach((el) => {
        const swiper = new Swiper (el, {
          slidesPerView: 1,
          spaceBetween: 24,
          on: {
            slideChange: function() {
              var isFeatureSlide;
              var changeTitle;
              var slideIndex;
              var eventsSwiper;
              var eventsSwiperTitle;
              var getActiveSlide;

              
              eventsSwiper = this;
              eventsSwiperTitle = document.querySelector('#home-page-events-title');

              getActiveSlide = function(swiper) {
                return swiper.slides[swiper.activeIndex]
              };

              isFeatureSlide = function(slide) {
                return slide.classList.contains('events-slider__slide--feature');
              };

              changeTitle = function(isFeatureSlide) {
                eventsSwiperTitle.innerHTML = isFeatureSlide ? 'Будущие' : 'Прошедшие';
              };
              
              setTimeout(function() {
               changeTitle(isFeatureSlide(getActiveSlide(eventsSwiper)));
              }, 100);
            },
            slideChangeTransitionStart: function(){
              setEventsCounter(el);
            },
            init: function(){
              setEventsCounter(el);
            },
          },
          navigation: {
            nextEl: '.next',
            prevEl: '.prev',
          },
          pagination: {
            el: el.querySelector('.swiper-pagination'),
            type: 'fraction',
          },
          breakpoints: {
            1024: {
              slidesPerView: 2,
              spaceBetween: 40
            }
          }
        })
    })
}